import styled from '@emotion/styled';
import React from 'react';

import TextSearch from '../../../../../../../app/components/common/TextSearch';

export const SearchFormElement = styled.form`
  margin-right: 15px;
`;

const SearchForm = () => (
  <SearchFormElement
    action="/search"
    role="search"
    method="get"
    autoComplete="off"
    className="header-search-form"
  >
    <TextSearch focusOnMount={false} mode="header" name="query" />
  </SearchFormElement>
);

export default SearchForm;
